import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useDeleteRate = (id) => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const history = useHistory();

	const destroy = async () => {
		const instance = await InitApi({ accessToken });
		const response = await instance.delete(`/currency-rates/${id}`);
		await queryClient.invalidateQueries("rates");
		return response;
	};

	return useMutation(destroy, {
		onSuccess: async ({ data: body }) => {
			toast.success(body.message);
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useDeleteRate;
